import { Component, OnInit, Inject,OnDestroy, AfterViewInit, ElementRef } from '@angular/core';
import { Utility } from '../../../common/utility';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { DialogService } from '../../../shared/services/dialog.service';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { UserUrl } from '../../../shared/urls/user.url';
import { BaseService } from '../../../shared/services/base.service';
import { ConsultationProcessService } from '../consultation-process.service';
import { ConsultationStep } from '../../../models/consultation/consultation.model';
import { PopupSummaryTripInformationService } from './pop-up-summary-trip-information.service';
import { BaseConsultationComponent } from '../base-consultation/base-consultation.component';
import { AppConstants } from '../../../shared/constants/constants';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';
declare var tripNote: any;
@Component({
  templateUrl: 'pop-up-summary-trip-information.component.html',
  providers: [PopupSummaryTripInformationService,ConsultationProcessService]
})

export class PopupSummaryTripInformationComponent extends BaseConsultationComponent implements OnInit, AfterViewInit, OnDestroy {
  public consultationStep: ConsultationStep;
  public klass = 'tripInformation';
  public countrySelected: any = null;
  public isValidateCountry = false;
  public regionSelected: Array<any> = [];
  public countryChosen: Array<any> = [];
  public regionList: Array<any> = null;
  public tripInformationData: any;
  public tripPresentations:any;
  public countries: any;
  public regions: any;
  public isChange = 0;
  public isGroupConsultation: any;
  public isOnlineMode: boolean = true;
  public tripSubscription: Subscription;
  public isViewInit = false;
  public isTripDataInit = false;
  public isMapLoaded = false;
  private timer$: Subscription;
  public consultationId=null;
  public patientId = null;
  constructor(public dialogService: DialogService,
    public consultationProcessService: ConsultationProcessService,
    public router: Router,
    public activeRouter: ActivatedRoute,
    public utility: Utility,
    public dialogRef: MdDialogRef<PopupSummaryTripInformationComponent>,
    public baseService: BaseService,
    public elementmapRef: ElementRef,
    private tripInformationService: PopupSummaryTripInformationService,
    @Inject(MD_DIALOG_DATA) public data: any) {
    super(dialogService, consultationProcessService, router, activeRouter, ConsultationStep.TripInformation );    
    // get next,prev action from consultationProcessBar        
    }

  ngOnInit() {
    
    this.clearRegionsFromLocalStorage();
    this.isGroupConsultation = this.data['patientId'] ? false : true;
    if (this.isGroupConsultation) {
      this.tripInformationService.getTripInformationGroup(this.data['consultationId']).subscribe(
        (result) => {
          if (result) {
            const trip = result.json();
            this.data = trip[0];
            if (this.data.tripCountries) {
              this.data.tripCountries.forEach(el => {
                const countryPattern = {
                  'id': el.id,
                  'name': el.name,
                  'countryRegions': el.countryRegions,
                  'destinationTypeId': el.destinationTypeId,
                  'isoCode': el.isoCode,
                };
                this.countryChosen.push(countryPattern);
              });
            }
            this.pushRegionToLocalStorage();
            if(this.data.tripPresentations)
            {
              localStorage.setItem(AppConstants.localStorage.tripPresentations, this.data.tripPresentations);
            }
            else this.clearTripPresentationsFromLocalStorage();
          }
        }
      );
    } else {
      this.tripInformationService.getTripInformation(this.data['consultationId']).subscribe(
        (result) => {
          if (result) {
            const trips = result.json();
            if (trips && trips.length > 0) {
              this.data = trips[0];
              if (this.data.tripCountries) {
                this.data.tripCountries.forEach(el => {
                  const countryPattern = {
                    'id': el.id,
                    'name': el.name,
                    'countryRegions': el.countryRegions,
                    'destinationTypeId': el.destinationTypeId,
                    'isoCode': el.isoCode
                  };
                  this.countryChosen.push(countryPattern);
                });
              }
              this.pushRegionToLocalStorage();
              // get trip presentation
              if(this.data.tripPresentations)
              {
                localStorage.setItem(AppConstants.localStorage.tripPresentations, this.data.tripPresentations);
              }
              else this.clearTripPresentationsFromLocalStorage();
            }
          }
        }
      );
    }

    this.tripInformationService.getCountries().subscribe(
      (result) => {
        if (result) {
          this.countries = result.json();
        }
      }
    );
  }

  ngAfterViewInit() {
    this.isViewInit = true;
    this.initOnlineMap();
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
   // this.tripSubscription.unsubscribe();
    this.subscription.unsubscribe();
  }

  initOnlineMap() {
    if (this.isViewInit && this.isTripDataInit) {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.text = `
        function TripExodusCallBack(selected) {
          this.isMapLoaded = true;
          tripNote = selected['Clipboard'];
        }
        (function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          var loader = d.getElementById(id);
          js = d.createElement(s); js.id = id;
          js.src = "//www.tmbworld.com/core-select/loader.js?timestamp=" + new Date().getTime();
          fjs.parentNode.insertBefore(js, fjs);
          if (loader){
            fjs.parentNode.removeChild(loader);
          }
         }(document, 'script', 'trip-consultant-loader'));
      `;
      this.elementmapRef.nativeElement.appendChild(s);
      this.isViewInit = false;
    }
  }
  
  /**
   * get localstorage Regions to build CountryRegions Object incase user use online mode
   */
  buildRegionsFromLocalStorage(): Observable<any[]> {
    const regionStorage = JSON.parse(localStorage.getItem(AppConstants.localStorage.regions));
    if (!this.isOnlineMode) {//(regionStorage && (!this.isOnlineMode || regionStorage.length === 0)) {
      return Observable.of(this.countryChosen);
    }

    for (let i = 0; i < this.countryChosen.length; i++) {
      const storageIndex = regionStorage.findIndex(c => c === this.countryChosen[i].isoCode);
      if (storageIndex < 0) {
        this.countryChosen.splice(i, 1);
        i--;
      }
    }
    //
    if(regionStorage.length==0)
    {
          this.data['departDate'] = null;
          this.data['returnDate'] = null;
          this.data['selectedAccomodationTypes'] = null;
          this.data['selectedTripReasons'] = null;
          this.data['week'] = 0;
    }

    // get region name from BE to fill in data in left column
    return this.tripInformationService.getRegionByCode(regionStorage).map(
      (result) => {
        let regionsCode = [];
        if (result) {
          regionsCode = result.json();
        }
        if (regionStorage && regionStorage.length > 0) {
          regionStorage.forEach(element => {
            if (element) {
              const isRegion = element.indexOf('-') !== -1;
              const countryCode = (isRegion) ? element.split('-')[0] : element;
              let index = -1;
              if (this.countries) {
                index = this.countries.findIndex(item => item.code === countryCode);
              }
              // check if country in online mode is exist in offline country
              if (index >= 0) {
                const chosenIndex = this.countryChosen.findIndex(country => country.isoCode === countryCode);
                if (chosenIndex < 0) {
                  if (!isRegion) {
                    this.countryChosen.push(this.createCountryPattern(this.countries[index], countryCode));
                  }
                } else {
                  if (isRegion) {
                    if (this.countryChosen[chosenIndex].countryRegions.findIndex(r => r.code === element) < 0) {
                      this.countryChosen[chosenIndex].countryRegions.push(this.createRegionPattern(regionsCode, element));
                    }
                  }
                }
              }
            }
          });
        }
        return this.countryChosen;
      });
  }

  /**
   * return country pattern in online mode
   * @param country
   * @param isoCode
   */
  createCountryPattern(country, isoCode) {
    return {
      'id': country.id,
      'name': country.name,
      'isoCode': isoCode,
      'countryRegions': [],
      'destinationTypeId': null
    };
  }

  /**
   * return region pattern in online mode
   * @param regions
   * @param regionCode
   */
  createRegionPattern(regions, regionCode) {
    const regionObj = regions.filter(obj => obj.code === regionCode);
    return {
      code: regionCode,
      name: (regionObj.length > 0) ? regionObj[0].name : ''
    };
  }

  clearRegionsFromLocalStorage() {
    localStorage.setItem(AppConstants.localStorage.regions, '[]');
  }
  clearTripPresentationsFromLocalStorage(){
    localStorage.setItem(AppConstants.localStorage.tripPresentations, '[]');
  }
  /**
   * remove regions localstorage
   */
  removeRegionFromLocalStorage(countryCode, regionCode = null) {
    const regionStorage = JSON.parse(localStorage.getItem(AppConstants.localStorage.regions));
    if (!this.isOnlineMode || regionStorage.length <= 0 || !countryCode) {
      return;
    }

    for (let index = 0; index < regionStorage.length; index++) {
      if (regionStorage[index]) {
        if (regionStorage[index].substring(0, countryCode.length) === countryCode && !regionCode) {
          regionStorage.splice(index, 1);
          index--;
        } else if (regionStorage[index] === countryCode) {
          // clear region
          regionStorage.splice(index, 1);
          index--;
        }
      }
    }
    localStorage.setItem(AppConstants.localStorage.regions, JSON.stringify(regionStorage));
  }
  onCloseCancel() {
    this.dialogRef.close({ data: '', action: 0 });
  }
  pushRegionToLocalStorage() {
    const storage = [];
    this.countryChosen.forEach(element => {
      storage.push(element['isoCode']);
      element.countryRegions.forEach(r => {
        storage.push(r['code']);
      });
    });
    localStorage.setItem(AppConstants.localStorage.regions, JSON.stringify(storage));
    this.isTripDataInit = true;
    this.initOnlineMap();
  }

  clearData() {
    localStorage.setItem("isReloadInfomation", "2");
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/pop-up-summary-trip-information/pop-up-summary-trip-information.component.ts